import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from "firebase/auth";
import {getStorage} from "firebase/storage";

// Add config logging to debug
const firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

// console.log('Firebase Config Loading:', {
//     apiKey: firebaseConfig.apiKey,
//     authDomain: firebaseConfig.authDomain,
//     projectId: firebaseConfig.projectId,
//     storageBucket: firebaseConfig.storageBucket,
//     messagingSenderId: firebaseConfig.messagingSenderId,
//     appId: firebaseConfig.appId,
//     measurementId: firebaseConfig.measurementId
// });

let analytics, auth, storage, currentUser;

try {
    const firebaseApp = initializeApp(firebaseConfig);
    console.log('Firebase App initialized successfully');

    analytics = getAnalytics(firebaseApp);
    console.log('Analytics initialized');

    auth = getAuth(firebaseApp);
    console.log('Auth initialized');

    storage = getStorage(firebaseApp);
    console.log('Storage initialized');

    // Add auth state listener
    auth.onAuthStateChanged((user) => {
        console.log('Auth state changed:', user ? 'User logged in' : 'No user');
        currentUser = user;
    });

} catch (error) {
    console.error('Firebase initialization error:', error);
}

export {
    analytics,
    auth,
    currentUser,
    storage
}